import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function KrivicnoProcesnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Krivično procesno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Krivično procesno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Krivično procesno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>{" "}
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>

              <h3>Cilj predmeta</h3>
              <p>
                Izučavanjem predmeta Krivično procesno pravo studenti stiču
                znanja o krivičnom postupku kojim država sprovodi borbu protiv
                kriminaliteta. Predmet pruža uvodna znanja o predmetu,
                subjektima i osnovnim načelima na kojima se bazira sistem
                krivičnog procesnog prava. Ciljevi ovog predmeta su postizanje i
                razvijanje naučnih saznanja, veština i praktičnih sposobnosti u
                tumačenju i primeni pravnih pravila u oblasti krivičnog
                procesnog prava, razvijanje kreativnih sposobnosti i ovladavanje
                metodima, postupcima i procesima istraživanja, ovladavanje
                specifičnim pravnim veštinama potrebnim za pravilno
                funkcionisanje krivičnog pravosuđa u demokratskom društvu i
                pravnoj državi, usklađivanje procesa edukacije i ciljeva
                predmeta sa dostignućima i savremenim pravcima nauke i prakse
                krivičnog procesnog prava.
              </p>

              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješno savladanog predmeta student će moći: definisati i
                razumeti osnovne pojmove i načela krivično procesnog prava;
                prepoznati i na ispravan način interpretirati glavne i sporedne
                izvore krivično procesnog prava; odrediti i opisati subjekte
                krivično procesnog prava, njihova prava i obaveze; opisati tok
                krivičnog postupka; razgraničiti i objasniti faze krivičnog
                postupka; utvrditi i objasniti vrste činjenica i načine
                utvrđivanja; kritički se odnositi prema zakonskim normama;
                sastaviti krivičnu prijavu, sastaviti rešenje o istražnom
                zatvoru, sastaviti optužnicu, žalbu i presudu i ostale pismene.
                Takođe, studenti će biti u mogućnosti da u svom profesionalnom
                angažmanu primene znanja stečena izučavanjem ovog predmeta i
                biće im olakšana adaptacija na novo okruženje kao i prelaz sa
                teorije na praksu.
              </p>

              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Osnovni pojmovi krivičnog procesnog prava;
                Pojam, karakteristike i tok krivičnog postupka; Nauka krivično
                procesnog prava; Predmet i zadatak krivičnog postupka; Izvori i
                tumačenje krivično procesnog prava; Istorijski razvoj krivičnog
                procesnog prava; Osnovna načela krivičnog postupka; Pojam,
                klasifikacija i načela krivičnoprocesnih subjekata; Krivični sud
                kao subjekt krivičnog postupka: uređenje i organizacija sudova;
                Nadležnost sudova: stvarna, mesna i funkcionalna nadležnost;
                Spajanje i razdvajanje krivičnog postupka; Izuzeće sudija; Pojam
                i vrste stranke u krivičnom postupku; Državni tužilac u
                krivičnom postupku; Oštećeni u krivičnom postupku; Okrivljeni i
                branilac okrivljenog u krivičnom postupku; Pojam, karakteristike
                i vrste krivičnoprocesnih radnji; Povraćaj u pređašnje stanje;
                Pojam i vrste činjenica koje se utvrđuju u krivičnom postupku;
                Pojam, vrste i teret pružanja dokaza; Pojam i vrste dokaznih
                sredstava u krivičnom postupku; Iskaz okrivljenog, svedoka i
                veštaka; Zaštita svedoka, svedok saradnik i mere tajnog nadzora;
                Podnesci i zapisnici u krivičnom postupku; Pojam i vrste sudskih
                odluka; Pojam i vrste presuda; Radnje procesne prinude; Mjere za
                obezbeđivanje prisutva okrivljenog i za nesmetano vođenje
                krivičnog postupka; Redovni krivični postupak; Izviđaj;
                Prethodni postupak; Optuženje; Glavni krivični postupak i
                postupak pred prvostepenim sudom; Pripremanje glavnog pretresa;
                Glavni pretres; Donošenje presude; Postupak po pravnim lekovima;
                Žalba na presudu prvostepenog suda; Vanredni pravni lekovi;
                Skraćeni krivični postupak; Postupak prema maloljetnicima;
                Posebni postupci: pružanje međunarodne krivične pomoći i trajno
                oduzimanje imovine čije zakonito poreklo nije dokazano.
                Praktična nastava: Praktična nastava se organizuje na fakultetu,
                kod privatnih lica (advokati, izvršitelji) kao i u državnim
                institucijama (sudovi, tužilaštvo). Praktična nastava se izvodi
                kroz analizu sudske prakse i analizu praktičnih primera. Takođe,
                studenti će na časovima predavanja i vežbi sačinjavati podneske
                i zapisnike u krivičnom postupku kao i pisati presude i rešenja.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vežbe,
                samostalni rad (seminarski rad, interaktivna nastava i
                upoznavanje sa praksom crnogorskih i međunarodnih sudova),
                pisanje optužnica, žalbi, presuda i ostalih pismena.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Osnovni pojmovi krivičnog procesnog prava; Pojam,
                      karakteristike i tok krivičnog postupka; Nauka krivično
                      procesnog prava; Predmet i zadatak krivičnog postupka
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Izvori i tumačenje krivično procesnog prava; Istorijski
                      razvoj krivičnog procesnog prava; Osnovna načela krivičnog
                      postupka
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam, klasifikacija i načela krivičnoprocesnih subjekata;
                      Krivični sud kao subjekt krivičnog postupka: uređenje i
                      organizacija sudova
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Nadležnost sudova: stvarna, mesna i funkcionalna
                      nadležnost; Spajanje i razdvajanje krivičnog postupka;
                      Izuzeće sudija
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam i vrste stranke u krivičnom postupku; Državni
                      tužilac u krivičnom postupku; Oštećeni u krivičnom
                      postupku
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>3P + 2V</td>
                    <td>
                      Okrivljeni i branilac okrivljenog u krivičnom postupku;
                      Pojam, karakteristike i vrste krivičnoprocesnih radnji
                    </td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Povraćaj u pređašnje stanje; Pojam i vrste činjenica koje
                      se utvrđuju u krivičnom postupku
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam, vrste i teret pružanja dokaza; Pojam i vrste
                      dokaznih sredstava u krivičnom postupku
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>
                      Iskaz okrivljenog, svedoka i veštaka; Zaštita svedoka,
                      svedok saradnik i mere tajnog nadzora
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>
                      Podnesci i zapisnici u krivičnom postupku; Pojam i vrste
                      sudskih odluka
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam i vrste presuda; Radnje procesne prinude; Mjere za
                      obezbeđivanje prisutva okrivljenog i za nesmetano vođenje
                      krivičnog postupka
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>3P + 2V</td>
                    <td>
                      Redovni krivični postupak; Izviđaj; Prethodni postupak
                    </td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Optuženje; Glavni krivični postupak i postupak pred
                      prvostepenim sudom; Pripremanje glavnog pretresa
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>
                      Glavni pretres; Donošenje presude; Postupak po pravnim
                      lekovima; Žalba na presudu prvostepenog suda
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Vanredni pravni lekovi; Skraćeni krivični postupak;
                      Postupak prema maloljetnicima
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>3P + 2V</td>
                    <td>
                      Pružanje međunarodne krivične pomoći; Trajno oduzimanje
                      imovine čije zakonito poreklo nije dokazano
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 4.3h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default KrivicnoProcesnoPravo;
